export const cabBookingColumns = [
    {
      Header: 'Id',
      accessor: 'id',
    },
    {
      Header: 'Car',
      accessor: 'car',
    },
    {
      Header: 'Car Number',
      accessor: 'carNumber',
    },
    {
      Header: 'Driver',
      accessor: 'driver',
    },
    {
      Header: 'Customer',
      accessor: 'customer',
    },
    {
      Header: 'Date',
      accessor: 'date',
    },
    {
        Header: 'Type',
        accessor: 'type',
    },
    {
        Header: 'Time',
        accessor: 'time',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

  export const cabBookingTableData = [
    {   
        id:'01',
        car:'Innova',
        carNumber:'AB-GB-0158',
        driver: 'Max',
        customer: 'Jemmy',
        date: '21/01/2024',
        type:'Pick Up',
        time:'08:20 AM'
    },
    {   
        id:'02',
        car:'XUV 700',
        carNumber:'AB-GB-1158',
        driver: 'Jone',
        customer: 'Cargo',
        date: '20/01/2024',
        type:'Drop',
        time:'10:20 PM'
    },
    {   
      id:'03',
      car:'Maruti 800',
      carNumber:'AB-GB-1111',
      driver: 'Jone',
      customer: 'Cargo',
      date: '20/01/2024',
      type:'Drop',
      time:'10:20 PM'
  },
  {   
      id:'04',
      car:'Hyundai Verna',
      carNumber:'AB-GB-7711',
      driver: 'Lucy',
      customer: 'Meddy',
      date: '20/06/2024',
      type:'Pick Up',
      time:'07:10 PM'
  },
  {   
      id:'05',
      car:'Maruti Dzire',
      carNumber:'AB-GB-9911',
      driver: 'Hetto',
      customer: 'Depo',
      date: '14/06/2024',
      type:'Drop',
      time:'08:20 PM'
  },
  {   
    id:'06',
    car:'Honda Amaze',
    carNumber:'AB-GB-1188',
    driver: 'Karry',
    customer: 'Atman',
    date: '17/05/2024',
    type:'Drop',
    time:'09:20 PM'
  },
  {   
    id:'07',
    car:'Volkswagen Virtus',
    carNumber:'AB-GB-1112',
    driver: 'Hiro',
    customer: 'Lina',
    date: '16/05/2024',
    type:'Pick Up',
    time:'10:20 PM'
  },
]